import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';

/**
 * Radio button for selecting a location
 *
 * @param {Object} props Component props
 * @param {string|number} props.locationIdn The IDN of this location
 * @param {string|number} props.selectedLocationIdn Currently selected location IDN
 * @param {Function} props.onSelect Function to call when selected
 * @returns {JSX.Element} Radio button component
 */
function LocationSelectionRadio({ locationIdn, selectedLocationIdn, onSelect }) {
  // Create a handler function to call onSelect with the locationIdn
  const handleChange = event => {
    if (event.target.checked) {
      onSelect(locationIdn);
    }
  };

  return <Radio checked={locationIdn === selectedLocationIdn} onChange={handleChange} />;
}

LocationSelectionRadio.propTypes = {
  locationIdn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedLocationIdn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

LocationSelectionRadio.defaultProps = {
  selectedLocationIdn: null,
};

export default LocationSelectionRadio;
